export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-arrows-expand-717c3e17abc3efaa63f589f1a0d8326a.svg";